import React from "react";

const Category = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.616 13.877H34v9.136h-9.384V19.64h-5.878v7.876h-7.354v3.373H2v-9.137h9.383v3.374h4.9V11.763h-4.9v3.374H2V6h9.383v3.373h7.355v7.877h5.878v-3.373Z"
            fill={fill}
        />
    </svg>
);

export default Category;